// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
export default class Loader extends React.Component {

    componentDidMount = () => {
        document.addEventListener("click", this.clickHandler); 
        this.id = this.props.id || 'DissmissContainer'; 
    };

    componentWillUnmount = () => {
        document.removeEventListener("click", this.clickHandler);
    };

    clickHandler = (event) => {
        // Get the container... 
        const container = document.getElementById(this.id); 
        if(!container || !event.target) return; 
        if (container?.contains(event.target)) {
            return;
        } 
        // Close the container...  
        this.props.onClose();  
    }

    render = () => {
        return(
            <div
                className='DissmissContainer'
                id={this.props.id ? this.props.id : 'DissmissContainer'}
                style={{
                    ...(this.props?.noZIndex?{}:{zIndex: 99999}),
                    ...(this.props?.noAbsolute?{}:{position: 'absolute'}),
                }}
            >
                {this.props.children}
            </div>
        )
    }
};